// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { awFileUploadRenderFunction } from 'js/DesAwFileDirUploadService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/DesAwFileDirUploadService', () => import('js/DesAwFileDirUploadService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "render": {
      "method": "awFileUploadRenderFunction",
      "deps": "js/DesAwFileDirUploadService",
      "options": {
        "useAria": true
      }
    }
  },
  "data": {
    "fileChosen": {
      "now": false
    },
    "isDragOn": false,
    "_attachedFiles": null
  },
  "conditions": {},
  "onEvent": [],
  "lifecycleHooks": {
    "render": "render"
  },
  "i18n": {
    "ChooseDir": ["DesImportDataMessages"],
    "ChooseFile": ["UIMessages"],
    "NoFileChosen": ["UIMessages"],
    "singleUpload": ["UIMessages"],
    "multipleUpload": ["UIMessages"]
  },
  "props": {
    "type-filter": {
      "type": "string"
    },
    "form-data": {
      "type": "object"
    },
    "file-change-action": {
      "type": "action"
    },
    "is-required": {
      "type": "object"
    },
    "multiple": {
      "type": "boolean"
    },
    "remove-tooltip": {
      "type": "string"
    }
  },
  "_viewModelId": "DesAwFileDirUpload",
  "_uniqueViewModelId": "DesAwFileDirUpload",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, awFileUploadRenderFunction, {
  "useAria": true
}, ctxImportObj);
export default Component;